export default __webpack_public_path__ + "static/media/usdc.c8494593.svg";